module.exports = __webpack_public_path__ + "img/bird_noping.ec5ccb86.svg";